/**
 * A service just refused a request the way a SWITCHED-OFF module refuses one: tell the app, so it asks
 * the server's module switches again instead of waiting for the next sign-in (review: the app read the
 * switches once per company and never again, so a signed-in person kept a stale menu).
 *
 * The switch's own refusals are a read's plain 404 {"detail": "Not Found"} and a save's 403
 * "<Module> is switched off for your company." / "<Module> is not enabled yet." (shared/module_switches.py).
 * A plain 404 is also what any unknown address answers, so it only ever triggers a RE-ASK - which the
 * provider throttles - never a conclusion.
 */
export const MODULE_REFUSED_EVENT = 'tynvara:module-refused'

const SWITCHED_OFF_WORDS = /is switched off for your company\.$|is not enabled yet\.$/

/** True for a 403 carrying the switch's own words. */
export const isSwitchedOffRefusal = (status, data) =>
  status === 403 && typeof data?.detail === 'string' && SWITCHED_OFF_WORDS.test(data.detail)

export function noteModuleRefusal(status, data) {
  const plainNotFound = status === 404 && data?.detail === 'Not Found'
  if (!plainNotFound && !isSwitchedOffRefusal(status, data)) return
  try {
    window.dispatchEvent(new CustomEvent(MODULE_REFUSED_EVENT))
  } catch {
    // no window (a test without jsdom): nothing to tell
  }
}
